import { getCurrentLocale, t , tm} from '@/locales/i18n';
import type { TechMeasuresProjectCard, TechMeasuresProjectInfo } from '@/types';
import { computed } from 'vue';
//es
import energyChemicalProductsEn from '@/assets/data/techMeasures/en/energy/chemicalProducts.json';
import equipmentImprovementEn from '@/assets/data/techMeasures/en/energy/equipmentImprovement.json';
import infrastructureEn from '@/assets/data/techMeasures/en/energy/infrastructure.json';
import maintenanceEn from '@/assets/data/techMeasures/en/energy/maintenance.json';
import meteringAndMonitoringEn from '@/assets/data/techMeasures/en/energy/meteringAndMonitoring.json';
import bestAvailableTechnologiesEn from '@/assets/data/techMeasures/en/energyAndWater/bestAvailableTechnologies.json';
import chemicalProductsEn from '@/assets/data/techMeasures/en/energyAndWater/chemicalProducts.json';
import manufacturingProcessEn from '@/assets/data/techMeasures/en/energyAndWater/manufacturingProcess.json';
import quickWinsEn from '@/assets/data/techMeasures/en/energyAndWater/quickWins.json';
import wastewaterEn from '@/assets/data/techMeasures/en/wastewater/wastewater.json';
import facilityInfraestructureEn from '@/assets/data/techMeasures/en/water/facilityInfraestructure.json';
import waterPollutantLoadReductionEn from '@/assets/data/techMeasures/en/water/waterPollutantLoadReduction.json';
//zh
import energyChemicalProductsZh from '@/assets/data/techMeasures/zh/energy/chemicalProducts.json';
import equipmentImprovementZh from '@/assets/data/techMeasures/zh/energy/equipmentImprovement.json';
import infrastructureZh from '@/assets/data/techMeasures/zh/energy/infrastructure.json';
import maintenanceZh from '@/assets/data/techMeasures/zh/energy/maintenance.json';
import meteringAndMonitoringZh from '@/assets/data/techMeasures/zh/energy/meteringAndMonitoring.json';
import bestAvailableTechnologiesZh from '@/assets/data/techMeasures/zh/energyAndWater/bestAvailableTechnologies.json';
import chemicalProductsZh from '@/assets/data/techMeasures/zh/energyAndWater/chemicalProducts.json';
import manufacturingProcessZh from '@/assets/data/techMeasures/zh/energyAndWater/manufacturingProcess.json';
import quickWinsZh from '@/assets/data/techMeasures/zh/energyAndWater/quickWins.json';
import wastewaterZh from '@/assets/data/techMeasures/zh/wastewater/wasteWater.json';
import facilityInfraestructureZh from '@/assets/data/techMeasures/zh/water/facilityInfraestructure.json';
import waterPollutantLoadReductionZh from '@/assets/data/techMeasures/zh/water/waterPollutantLoadReduction.json';
//tr
import energyChemicalProductsTr from '@/assets/data/techMeasures/tr/energy/chemicalProducts.json';
import equipmentImprovementTr from '@/assets/data/techMeasures/tr/energy/equipmentImprovement.json';
import infrastructureTr from '@/assets/data/techMeasures/tr/energy/infrastructure.json';
import maintenanceTr from '@/assets/data/techMeasures/tr/energy/maintenance.json';
import meteringAndMonitoringTr from '@/assets/data/techMeasures/tr/energy/meteringAndMonitoring.json';
import bestAvailableTechnologiesTr from '@/assets/data/techMeasures/tr/energyAndWater/bestAvailableTechnologies.json';
import chemicalProductsTr from '@/assets/data/techMeasures/tr/energyAndWater/chemicalProducts.json';
import manufacturingProcessTr from '@/assets/data/techMeasures/tr/energyAndWater/manufacturingProcess.json';
import quickWinsTr from '@/assets/data/techMeasures/tr/energyAndWater/quickWins.json';
import wastewaterTr from '@/assets/data/techMeasures/tr/wastewater/wasteWater.json';
import facilityInfraestructureTr from '@/assets/data/techMeasures/tr/water/facilityInfraestructure.json';
import waterPollutantLoadReductionTr from '@/assets/data/techMeasures/tr/water/waterPollutantLoadReduction.json';

function getProjectData(locale: string) {
  if (locale === 'zh') {
    return {
      energyChemicalProducts: energyChemicalProductsZh,
      equipmentImprovement: equipmentImprovementZh,
      infrastructure: infrastructureZh,
      maintenance: maintenanceZh,
      meteringAndMonitoring: meteringAndMonitoringZh,
      bestAvailableTechnologies: bestAvailableTechnologiesZh,
      chemicalProducts: chemicalProductsZh,
      manufacturingProcess: manufacturingProcessZh,
      quickWins: quickWinsZh,
      wastewater: wastewaterZh,
      facilityInfraestructure: facilityInfraestructureZh,
      waterPollutantLoadReduction: waterPollutantLoadReductionZh
    };
  } else if (locale === 'tr') {
    return {
      energyChemicalProducts: energyChemicalProductsTr,
      equipmentImprovement: equipmentImprovementTr,
      infrastructure: infrastructureTr,
      maintenance: maintenanceTr,
      meteringAndMonitoring: meteringAndMonitoringTr,
      bestAvailableTechnologies: bestAvailableTechnologiesTr,
      chemicalProducts: chemicalProductsTr,
      manufacturingProcess: manufacturingProcessTr,
      quickWins: quickWinsTr,
      wastewater: wastewaterTr,
      facilityInfraestructure: facilityInfraestructureTr,
      waterPollutantLoadReduction: waterPollutantLoadReductionTr
    };
  } else {
    return {
      energyChemicalProducts: energyChemicalProductsEn,
      equipmentImprovement: equipmentImprovementEn,
      infrastructure: infrastructureEn,
      maintenance: maintenanceEn,
      meteringAndMonitoring: meteringAndMonitoringEn,
      bestAvailableTechnologies: bestAvailableTechnologiesEn,
      chemicalProducts: chemicalProductsEn,
      manufacturingProcess: manufacturingProcessEn,
      quickWins: quickWinsEn,
      wastewater: wastewaterEn,
      facilityInfraestructure: facilityInfraestructureEn,
      waterPollutantLoadReduction: waterPollutantLoadReductionEn
    };
  }
}

const projectData = computed(() => {
  const currentLocale = getCurrentLocale();
  return getProjectData(currentLocale);
});



export const allTechProjectsInfo = computed(() => [
  ...projectData.value.wastewater,
  ...projectData.value.energyChemicalProducts,
  ...projectData.value.equipmentImprovement,
  ...projectData.value.infrastructure,
  ...projectData.value.maintenance,
  ...projectData.value.meteringAndMonitoring,
  ...projectData.value.facilityInfraestructure,
  ...projectData.value.waterPollutantLoadReduction,
  ...projectData.value.bestAvailableTechnologies,
  ...projectData.value.chemicalProducts,
  ...projectData.value.manufacturingProcess,
  ...projectData.value.quickWins
]);

const QUICK_WINS_CATEGORY_EN = 'quick wins';
const QUICK_WINS_CATEGORY_ZH = '速效方案';
const QUICK_WINS_CATEGORY_TR = 'quick wins';

const getCalculatedImpactType = (impactValue: string) => {
  let calculatedImpact = '0';
  switch (impactValue.toLowerCase()) {
    case 'very high':
    case '很高':
    case 'çok yüksek':
      calculatedImpact = '4';
      break;
    case 'high':
    case '高':
    case 'yüksek':
      calculatedImpact = '3';
      break;
    case 'medium':
    case '中等':
    case 'orta':
      calculatedImpact = '2';
      break;
    case 'low':
    case '低':
    case 'düşük':
      calculatedImpact = '1';
      break;
  }
  return calculatedImpact;
};

const getProjectAllImpact = (project: TechMeasuresProjectInfo) => {
  const calculatedImpact: string[] = [];

  project.impactEnergy && calculatedImpact.push(project.impactEnergy);

  project.impactWater && calculatedImpact.push(project.impactWater);

  return calculatedImpact;
};

const getProjectTags = (project: TechMeasuresProjectInfo) => {
  const currentTags = [];

  if (project.estimatedInvestmentExpenditureSumup) {
    currentTags.push({
      tag: project.estimatedInvestmentExpenditureSumup,
      color: '',
      tooltip: tm('techAndMeasureTagTooltips.investementExpenditure').find(
        (data) => data.value === project.estimatedInvestmentExpenditureSumup.trim()
      )?.text,
      isSmallTooltip: true
    });
  }

  if (project.impactEnergy) {
    currentTags.push({
      tag: `${t('techAndMeasures.impactEnergy')} ${project.impactEnergy}`,
      color: '',
      tooltip: tm('techAndMeasureTagTooltips.impactEnergy').find(
        (data) => data.value === project.impactEnergy?.trim().toLowerCase()
      )?.text
    });
  }

  if (project.impactWater) {
    currentTags.push({
      tag: `${t('techAndMeasures.impactWater')} ${project.impactWater}`,
      color: '',
      tooltip: tm('techAndMeasureTagTooltips.impactWater').find(
        (data) => data.value === project.impactWater?.trim().toLowerCase()
      )?.text
    });
  }

  return currentTags;
};

const getProjectsByType = (typeProjects: TechMeasuresProjectInfo[]): TechMeasuresProjectCard[] => {
  return typeProjects.length
    ? typeProjects.map((project: TechMeasuresProjectInfo) => ({
        id: project.id,
        supertitle: project.category,
        title: project.measure,
        tags: getProjectTags(project),
        description: '',
        category: project.category,
        type: project.type,
        typeId: project.typeId,
        isTopProject: project.isTopProject,
        imageSrc: project.image ?? defaultMeasureImage,
        manufacturingProcess: project.manufacturingProcess,
        parameter: project.parameter,
        etpType: project.etpType,
        impact: getProjectAllImpact(project),
        impactEnergy: getCalculatedImpactType(project.impactEnergy ?? ''),
        impactWater: getCalculatedImpactType(project.impactWater ?? ''),
        estimatedInvestmentExpenditureSumup: project.estimatedInvestmentExpenditureSumup
      }))
    : [];
};

export const defaultMeasureImage = 'background/background_1.webp';

export const energyProjectsCards = computed(() => {
  return getProjectsByType([
    ...projectData.value.energyChemicalProducts,
    ...projectData.value.equipmentImprovement,
    ...projectData.value.infrastructure,
    ...projectData.value.maintenance,
    ...projectData.value.meteringAndMonitoring,
  ]);
});

export const energyWaterProjectsCards = computed(() => {
  return getProjectsByType([
    ...projectData.value.bestAvailableTechnologies,
    ...projectData.value.chemicalProducts,
    ...projectData.value.manufacturingProcess,
    ...projectData.value.quickWins,
  ]);
});

export const wastewaterProjectsCards = computed(() => {
  return getProjectsByType([...projectData.value.wastewater]);
});

export const waterProjectsCards = computed(() => {
  return getProjectsByType([
    ...projectData.value.facilityInfraestructure,
    ...projectData.value.waterPollutantLoadReduction,
  ]);
});

export const techMeasuresProjectsCards = computed(() => [
  ...wastewaterProjectsCards.value,
  ...energyProjectsCards.value,
  ...waterProjectsCards.value,
  ...energyWaterProjectsCards.value,
]);

export const allTechMeasuresProjectsCards = computed(() =>
  techMeasuresProjectsCards.value.filter(
    (project) => {
      const category = project.category?.toLowerCase();
      return category !== QUICK_WINS_CATEGORY_ZH && category !== QUICK_WINS_CATEGORY_EN && category !== QUICK_WINS_CATEGORY_TR;
    }
  )
);

export const quickWinsProjectsCards = computed(() =>
  techMeasuresProjectsCards.value.filter(
    (project) => {
      const category = project.category?.toLowerCase();
      return category === QUICK_WINS_CATEGORY_ZH || category === QUICK_WINS_CATEGORY_EN || category === QUICK_WINS_CATEGORY_TR;
    }
  )
);

export const topTechMeasuresProjectsCards = computed(() =>
  techMeasuresProjectsCards.value.filter((project) => project.isTopProject)
);